import { PredefinedColors } from '@ionic/core'
import { createDomain } from 'effector'
import { ParseKeys } from 'i18next'

const domain = createDomain('notifications')

type Message = {
  message: string
  messageI18n?: never
}

type MessageI18n = {
  message?: never
  messageI18n: ParseKeys
}

type EnqueueParams = {
  variant: PredefinedColors
} & (Message | MessageI18n)

export const snackbarEnqueued = domain.createEvent<EnqueueParams>()
export const snackbarClosed = domain.createEvent<string>()
export const allSnackbarsClosed = domain.createEvent()

type Snackbar = {
  key: string
} & EnqueueParams

export const $notifications = domain
  .createStore<Snackbar[]>([])
  .on(snackbarEnqueued, (state, payload) => [
    ...state,
    {
      key: String(new Date().getTime() + Math.random()),
      ...payload,
    },
  ])
  .on(snackbarClosed, (notifications, key) =>
    notifications.filter((notification) => notification.key !== key),
  )
  .on(allSnackbarsClosed, () => [])
